import { useState, useEffect } from 'react';
import FontFaceObserver from 'fontfaceobserver';

type Fonts = Record<string, number[]>;

export default (fonts: Fonts) => {
  const loadingFonts: Promise<void>[] = [];
  const [loaded, setLoaded] = useState(false);

  for (const font in fonts)
    loadingFonts.push(
      ...fonts[font].map((weight) =>
        new FontFaceObserver(font, { weight }).load()
      )
    );

  useEffect(() => {
    Promise.all(loadingFonts).then(
      () => setLoaded(true),
      () => setLoaded(false)
    );
  });

  return loaded;
};
